import type {ReactElement} from 'react';
import {getRightPanelSector} from '@FormMakerReact/layout/form-maker-right-panel/right-panel-registry';
import {ControlTile} from '@FormMakerReact/layout/form-maker-bottom-bar/components/control-tile/control-tile';
import {getComponentType} from '@FormMakerReact/lib/form-maker-canvas-library';
import {getTileEntries} from '@FormMakerReact/lib/form-maker-tile-meta-library';
import type {TileListProps} from './tile-list.types';
import styles from './tile-list.module.scss';

export function TileList({selected}: TileListProps): ReactElement | null {
  if (!selected) {
    return null;
  }
  const sector = getRightPanelSector(getComponentType(selected));
  const entries = sector ? getTileEntries(sector.controls, selected) : [];
  if (entries.length === 0) {
    return null;
  }

  return (
    <div className={styles.list} role="toolbar" aria-label={window.i18next.t('pmwjs_form_maker_mobile_controls_aria')}>
      {entries.map((entry) => (
        <ControlTile key={entry.meta.labelKey} entry={entry} />
      ))}
    </div>
  );
}
